import axios from 'axios'
import _ from 'lodash'

import {ApplicationPath} from "../class/ApplicationPath"
import {Project} from '../class/project'
import {DateUtil} from "../util/DateUtil";

const PROJECT_TABLE: string = 'project'

export class ProjectService {

    projecten: object[]
    projectenLookup: {}

    constructor() {
    }

    getProject = (id) => {
        return new Promise((resolve, reject) => {
            this.getProjecten().then(() => {
                resolve(this.projectenLookup[id])
            })
        })
    }

    getProjecten = () => {
        return new Promise((resolve, reject) => {

            if (this.projecten) {
                resolve(this.projecten)
                return
            }

            //GET /records/posts?join=comments,users&join=tags

            const url = `${ApplicationPath.CRUD}${PROJECT_TABLE}/?transform=1&order=id,desc&token=${ApplicationPath.API_KEY}`
            axios.get(url)
                .then(response => {
                    this.projecten = response.data[PROJECT_TABLE]
                    this.projectenLookup = _.keyBy(this.projecten, 'id')
                    resolve(this.projecten)
                })
                .catch(error => {
                    console.error('GET PROJECTS ERROR', error)
                    reject(error)
                })
        })
    }


    updateProject = (project) => {

        //project.datum_wijziging = DateUtil.getNowMysql()

        const url = `${ApplicationPath.CRUD}${PROJECT_TABLE}/${project.id}?transform=1&token=${ApplicationPath.API_KEY}`

        return new Promise((resolve, reject) => {
                axios.put(url, project)
                    .then((result) => {
                        resolve(result)
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    }

    createProject = (project) => {

        return new Promise((resolve, reject) => {
            let url = `${ApplicationPath.CRUD}${PROJECT_TABLE}/?transform=1&token=${ApplicationPath.API_KEY}`

            axios.post(url, project)
                .then((result) => {
                    console.log('CPR', result)
                    project.id = result.data
                    project.naam = 'Nieuw project'
                    project.datum_aanmaak = DateUtil.getNowMysql()
                    this.projecten = [project, ...this.projecten]

                    resolve({project, projecten: this.projecten})
                })
                .catch((error) => {
                    console.log(error)
                    reject(error)
                })
        })
    }

    deleteProject = (project) => {

        return new Promise((resolve, reject) => {

            //DELETE OEFENINGEN

            const url = `${ApplicationPath.CRUD}project/${project.id}?transform=1&token=${ApplicationPath.API_KEY}`

            axios.delete(url)
                .then((result) => {
                    this.projecten = this.projecten.filter(p => p['id'] !== project.id)

                    resolve({projecten: this.projecten})
                })
                .catch((error) => {
                    console.log(error)
                    reject(error)
                })
        })
    }


}
